import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAdminOpenItemsListAction,
  resetOpenItemsFetching,
  resetOpenItemsError,
  resetOpenItemsSuccess,
  resetAdminOpenItemsList,
  sendOpenItemEmailAction,
  resetEmailSuccess,
} from "../../../redux/openItems";
import { resetSession } from "../../../redux/auth";
import {
  INVOICE_EXPENSE_HEADER,
  PAGINATION_INITIAL,
} from "../../../constant/invoiceListConst";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
} from "../../../components/commons";
import { EmptyPage } from "../../../assets/images";
import OpenItemTable from "../../../components/OpenItems/OpenItemTable";
import { OPEN_ITEM_HEADER } from "../../../constant/tableHeadersConstants/openItemsHeadersConst";
import { EmptyDocumentData } from "../../../components/OpenItems";
import SharedOpenItemsTable from "../../../components/OpenItems/Admin/SharedOpenItemsTable";
import { SearchIcon } from "../../../components/Icon";
import {
  GetAdminOpenItemsListingPayload,
  SendOpenItemEmailPayload,
} from "../../../commonTypes/openItemsTypes";
import toast, { Toaster } from "react-hot-toast";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type TabsType = {
  name: string;
  label: string;
};

const TABS: TabsType[] = [
  {
    name: "My Open Items",
    label: "mine",
  },
  {
    name: "Shared With Me",
    label: "shared",
  },
];

interface Props {
  history?: any;
  error?: any;
  token: string | null;
  statusCode: any;
  adminOpenItemList: any;
  sharedOpenItemsList: any;
  success: any;
  message: string | null;
  fetching: boolean;
  emailSuccess: number | null;
  dispatchGetAdminOpenItemsListAction: Function;
  dispatchResetOpenItemsError: Function;
  dispatchResetSession: Function;
  dispatchResetOpenItemsSuccess: Function;
  dispatchResetOpenItemsFetching: Function;
  dispatchSendOpenItemEmailAction: (data: SendOpenItemEmailPayload) => void;
  dispatchResetSendOpenItemEmailSuccessAction: () => void;
}

const AdminOpenItemsList = ({
  success,
  fetching,
  statusCode,
  history,
  token,
  error,
  message,
  emailSuccess,
  adminOpenItemList,
  sharedOpenItemsList,
  dispatchResetOpenItemsFetching,
  dispatchResetSession,
  dispatchResetOpenItemsSuccess,
  dispatchResetOpenItemsError,
  dispatchGetAdminOpenItemsListAction,
  dispatchSendOpenItemEmailAction,
  dispatchResetSendOpenItemEmailSuccessAction,
}: Props) => {
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : 0;

  const currentTab = history?.location?.state?.currentTab
    ? history?.location?.state?.currentTab
    : TABS[0].label;

  const [searchState, setSearchState] = useState(false);
  const [pagination, setPagination] = useState(PAGINATION_INITIAL);
  const [sharedPagination, setSharedPagination] = useState(PAGINATION_INITIAL);
  const [searchData, setSearchData] = useState("");
  const [activeTab, setActiveTab] = useState(currentTab);

     	//==========User Management ==========//
	const [isAddOpenItemPresent, setIsAddOpenItemPresent] = useMenuCheck();
  const [isEditOpenItemPresent, setIsEditOpenItemPresent] = useMenuCheck();
  const [isViewOpenItemPresent, setIsViewOpenItemPresent] = useMenuCheck();
	//====================//


  useEffect(() => {
    let data = {
      client_code,
      offset: 0,
      limit: 10,
      token,
    };
    setIsEditOpenItemPresent("Edit Open Item","menu")
    setIsViewOpenItemPresent("View Open Item","menu")
    setIsAddOpenItemPresent("Add Open Item","menu")
    dispatchGetAdminOpenItemsListAction(data);
    dispatchResetOpenItemsError();
    dispatchResetOpenItemsSuccess();
  }, []);

  const fetchNewData = (offset?: number, limit?: number, search?: string) => {
    if (token) {
      if (search) setSearchState(true);

      let finalData = {
        token,
        client_code,
        offset: offset || 0,
        limit: limit || 10,
        search_term: search
          ? search
          : searchData && searchData.length >= 3
          ? searchData
          : "",
      };
      dispatchGetAdminOpenItemsListAction(finalData);
    }
    dispatchResetOpenItemsError();
    dispatchResetOpenItemsSuccess();
  };

  const handleCallResetSessionFunctions = () => {
    dispatchResetOpenItemsFetching();
    dispatchResetSession();
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData && searchData.length >= 3) {
        fetchNewData(0, 10, searchData);
        setPagination(PAGINATION_INITIAL);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let data = {
        client_code,
        offset: 0,
        limit: 10,
        token,
      };
      dispatchGetAdminOpenItemsListAction(data);
    }
  };

  // const handleSearch = (e: any) => {
  // 	let value = e.target.value
  // 	setSearchData(value)
  // 	if (value && value.length >= 3) {
  // 		fetchNewData(0, 10, value)
  // 		setPagination(PAGINATION_INITIAL)
  // 	}
  // 	else if (value.length === 0) {
  // 		fetchNewData(0, 10, "")
  // 		setPagination(PAGINATION_INITIAL)
  // 	}
  // }

  const updatePagination = (data: any) => {
    if (activeTab === "mine") {
      setPagination(data);
    } else if (activeTab === "shared") {
      setSharedPagination(data);
    }
  };

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    setPagination(PAGINATION_INITIAL);
    setSharedPagination(PAGINATION_INITIAL);
    fetchNewData(0, 10);
    setPagination(PAGINATION_INITIAL);
  };

  const renderTabs = () => {
    let finalTab = TABS.map((tab: TabsType) => {
      return (
        <div
          className="tab-style mr-5 "
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          <div
            className={`tab-header ${activeTab === tab.label ? "active" : ""}`}
          >
            {tab.name}
          </div>
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  const handleSendOpenItemEmail = (id: number) => {
    if (token && id) {
      let finalData: SendOpenItemEmailPayload = {
        open_item_id: id,
        token,
      };

      dispatchSendOpenItemEmailAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired"
            buttonText="Logout"
            onPress={() => handleCallResetSessionFunctions()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => dispatchResetOpenItemsError()}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={message || "Document Added Successfully!"}
          buttonText="OK"
          onPress={() => {
            fetchNewData();
            dispatchResetOpenItemsSuccess();
          }}
          statusCode={statusCode}
        />
      );
    } else if (emailSuccess === 1) {
      dispatchResetSendOpenItemEmailSuccessAction();
      toast.success(`Email Sent Successfully!`, {
        duration: 2000,
      });
    } else if (emailSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired"
            buttonText="Logout"
            onPress={() => handleCallResetSessionFunctions()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        dispatchResetSendOpenItemEmailSuccessAction();
        toast.error(
          `Please wait at least 24-hours before sending email to this client again!`,
          {
            duration: 3000,
          }
        );
      }
    }

    return false;
  };

  let component = (
    <OpenItemTable
      data={adminOpenItemList?.data}
      count={adminOpenItemList?.count}
      fetchNewData={fetchNewData}
      fetching={fetching}
      type=""
      client_code={client_code}
      history={history}
      tableHeader={OPEN_ITEM_HEADER}
      handleSearch={handleSearch}
      pagination={pagination}
      updatePagination={updatePagination}
      activeTab={activeTab}
      handleSendOpenItemEmail={handleSendOpenItemEmail}
      isEditOpenItemPresent={isEditOpenItemPresent}
      isViewOpenItemPresent={isViewOpenItemPresent}
    />
  );
  if (activeTab === "mine") {
    component = (
      <OpenItemTable
        data={adminOpenItemList?.data}
        count={adminOpenItemList?.count}
        fetchNewData={fetchNewData}
        fetching={fetching}
        type=""
        client_code={client_code}
        history={history}
        tableHeader={OPEN_ITEM_HEADER}
        handleSearch={handleSearch}
        pagination={pagination}
        updatePagination={updatePagination}
        activeTab={activeTab}
        handleSendOpenItemEmail={handleSendOpenItemEmail}
        isEditOpenItemPresent={isEditOpenItemPresent}
        isViewOpenItemPresent={isViewOpenItemPresent}
      />
    );
  } else if (activeTab === "shared") {
    component = (
      <SharedOpenItemsTable
        data={sharedOpenItemsList?.data}
        count={sharedOpenItemsList?.count}
        fetchNewData={fetchNewData}
        fetching={fetching}
        type=""
        client_code={client_code}
        history={history}
        tableHeader={OPEN_ITEM_HEADER}
        handleSearch={handleSearch}
        pagination={sharedPagination}
        updatePagination={updatePagination}
        activeTab={activeTab}
        handleSendOpenItemEmail={handleSendOpenItemEmail}
      />
    );
  }

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Open items" />
      </div>
      <div className="col-md-6">
        <div className="d-flex flex-row justify-content-end mr-5">
          {adminOpenItemList.length !== 0 && isAddOpenItemPresent && (
            <Link
              className="btn btn-primary"
              to={{
                pathname: "/open-items-admin/add",
              }}
            >
              + Add Open Item
            </Link>
          )}
        </div>
      </div>

      <div className="col-md-12 mt-4">
        <div className=" mb-3 tab-container d-flex flex-row justify-content-start align-items-center">
          {renderTabs()}
        </div>
        <div className="content-area">
          <div className="row">
            <div className="col-md-8"></div>
            <div className="col-md-4">
              <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                placeholder="Search Document (Min. 3 characters)"
                onChange={(e) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
              />
            </div>
          </div>
          {adminOpenItemList?.count === 0 && !searchState ? (
            <EmptyDocumentData
              heading="Start adding open items by clicking the button below"
              showAddButton
            />
          ) : (
            component
          )}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
  fetching: state.openItems.fetching,
  error: state.openItems.error,
  success: state.openItems.success,
  statusCode: state.openItems.statusCode,
  adminOpenItemList: state.openItems.adminOpenItemList,
  sharedOpenItemsList: state.openItems.sharedOpenItemsList,
  message: state.openItems.message,
  emailSuccess: state.openItems.emailSuccess,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
  dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
  dispatchGetAdminOpenItemsListAction: (
    data: GetAdminOpenItemsListingPayload
  ) => dispatch(getAdminOpenItemsListAction(data)),
  dispatchResetOpenItemsFetching: (data: any) =>
    dispatch(resetOpenItemsFetching()),
  dispatchSendOpenItemEmailAction: (data: SendOpenItemEmailPayload) =>
    dispatch(sendOpenItemEmailAction(data)),
  dispatchResetSendOpenItemEmailSuccessAction: () =>
    dispatch(resetEmailSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminOpenItemsList);
